/**
 * Asynchronously loads the components for Campus Placement Drives
 */

import { lazyLoad } from 'utils/loadable';

export const CampusPlacementDashboard = lazyLoad(
  () => import('./PlacementDashboard'),
  module => module.CampusPlacementDashboard,
);

export const CampusDriveDetails = lazyLoad(
  () => import('./DriveDetails'),
  module => module.CampusDriveDetails,
);

export const CampusJobRounds = lazyLoad(
  () => import('./JobRounds'),
  module => module.CampusJobRounds,
);

export const CampusJobDetails = lazyLoad(
  () => import('./JobDetails'),
  module => module.CampusJobDetails,
);